import type { PageContext } from '@zto/zpage'
import { commonOptions } from '@/config/options'
import { RbacRoleScopeType, RbacRoleScopeTypeName } from '@/config/enums'

/** 接口 roleType 可能为单值、逗号分隔或多值（兼容旧数据） */
function normalizeRoleType(roleType: unknown): string {
  if (roleType == null || roleType === '') return RbacRoleScopeType.HEADQUARTERS
  if (Array.isArray(roleType)) {
    const first = roleType[0]
    return first != null ? String(first) : RbacRoleScopeType.HEADQUARTERS
  }
  const s = String(roleType).trim()
  if (!s) return RbacRoleScopeType.HEADQUARTERS
  const first = s.split(',')[0].trim()
  return first || RbacRoleScopeType.HEADQUARTERS
}

export function roleTypeLabel(row: any) {
  const t = row?.roleType
  if (t == null || t === '') return '--'
  const parts = String(t)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
  const labels = parts.map(p => RbacRoleScopeTypeName[p] || p)
  return labels.length ? labels.join('、') : '--'
}

/**
 * 新建 / 编辑角色：表单项走低码 formItems，资源勾选树为独立组件 CResourcePermTree
 */
export function roleEditDialog(isEdit: boolean) {
  return {
    width: 720,
    bodyHeight: '62vh',
    top: '6vh',
    labelWidth: 110,
    itemSpan: 24,
    formItems: [
      ...(isEdit
        ? [
            {
              type: 'text',
              prop: 'roleCode',
              label: '角色编码',
              span: 24
            }
          ]
        : []),
      {
        type: 'input',
        prop: 'roleName',
        label: '角色名称',
        span: 24,
        trim: true,
        maxlength: 10,
        required: true
      },
      {
        type: 'select',
        prop: 'roleType',
        label: '角色类型',
        span: 24,
        options: commonOptions.rbacRoleScopeType,
        required: true
      },
      {
        prop: 'resourceCodes',
        label: '页面权限',
        span: 24,
        showSlot: true,
        autoHeight: true,
        rules: [
          {
            validator: (_r: any, v: any, cb: any) => {
              if (Array.isArray(v) && v.length > 0) cb()
              else cb(new Error('请至少选择一个页面权限'))
            },
            trigger: 'change'
          }
        ],
        cmpt: { type: 'CResourcePermTree' }
      }
    ],
    onShow: async ({ data }: PageContext) => {
      if (!isEdit) {
        return {
          payload: {
            roleName: '',
            roleType: RbacRoleScopeType.HEADQUARTERS,
            resourceCodes: [] as string[]
          }
        }
      }
      const row = data?.row || data
      const codes = row.resourceCodes ?? row.pageCodes ?? []
      return {
        payload: {
          ...row,
          roleType: normalizeRoleType(row.roleType),
          resourceCodes: Array.isArray(codes) ? [...codes] : []
        }
      }
    },
    beforeSubmit: async (ctx: PageContext) => {
      const m = ctx.data
      if (!isEdit) {
        delete m.roleCode
      }
      delete m.pageCodes
      delete m.roleTypeTags
      if (m.roleType != null && m.roleType !== '') {
        m.roleTypes = [m.roleType]
        delete m.roleType
      }
      return true
    },
    actions: { close: {}, submit: { label: '保存' } }
  }
}
